import React from 'react';
import './CardSectionHeading.css';

export default ({ children, actionTitle, onAction, actionProps }) => (
  <h3 className="CardSectionHeading">
    {children}
    {actionTitle && onAction && (
      <button
        {...actionProps}
        className="CardSectionHeading-action"
        onClick={onAction}
      >
        {actionTitle}
      </button>
    )}
  </h3>
);
